import axiosInstance from "@/shared/api/axios"
import type { LoginPayload, Session, SessionResponse } from "./types"

/**
 * The session token never reaches this code: the backend answers with an httpOnly cookie,
 * so the only thing the browser learns here is who it is now logged in as.
 */
export async function login(payload: LoginPayload): Promise<Session> {
  const { data } = await axiosInstance.post<SessionResponse>("/auth/login", payload)

  return { user: data.user, expiresAt: data.expiresAt }
}

export async function logout(): Promise<void> {
  await axiosInstance.post("/auth/logout")
}

export async function fetchSession(): Promise<Session> {
  const { data } = await axiosInstance.get<SessionResponse>("/auth/me")

  return { user: data.user, expiresAt: data.expiresAt }
}
